module.controller('profileCtrl', ['$scope', '$state', '$stateParams', '$http', 'Transform', 'Session', 'brandService', 'OVERLAY', 'STATES', 'baseURI', 'cacheService', function ($scope, $state, $stateParams, $http, Transform, Session, brandService, OVERLAY, STATES, baseURI, cacheService){
  var url = baseURI + 'cardholder/profile';
  var urlWithUsername = url + '?Username=' + encodeURIComponent($stateParams.username);

  $scope.alert = {};
  $scope.alert.alertShown = false;
  $scope.alert.alertMessage = 'We\'re currently processing your card, and are unable to update your address at this time. ' +
    'If you entered an incorrect address when you joined ' + $scope.brand.programName + ', please contact customer service at (855) 525-4626';
  $scope.overlay = OVERLAY['member.home.profile'];
  $scope.states = STATES;
  $scope.attempted = false;

  $scope.showPassword = !$scope.brand.ssoHide;

  getProfile();

  function getProfile(){
    $http.get(urlWithUsername).then(function (resp){
      var data = resp.data;
      // Add json object to use in select/options
      var state = {key: data.Data.StateCode.replace(/\s+/g, ''), state: ''};
      $scope.formData = {
        Address: data.Data.Address1,
        AddressSuite: data.Data.Address2,
        City: data.Data.City,
        PostalCode: data.Data.PostalCode,
        State: state,
        Phone: data.Data.Phone.replace(/\D+/g, ''),
        Email: data.Data.Email
      };

      if (data.Data.Address1.indexOf('3611 PAESANOS PKWY') != -1) {
        $scope.title = "Default Address";
        $scope.info = "The physical address listed in your profile may be a default address. To make purchases online easier, we recommend updating it to your personal address.";
      }
    }).catch(function(error){
      console.log('err', error);
    });
  }

  $scope.attemptSubmission = function (formData){
    if(formData.$valid){
      $scope.alert.errorShown = false;
      $state.go('member.home.profile.step2');
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  $scope.processForm = function(formData){
    $scope.loading = true;
    formData.StateCode = formData.State.key;
    formData.Username = $stateParams.username;

    $http({
      method: 'PUT',
      url: url,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(formData)
    }).then(function (resp){
      var data = resp.data;

      if(data.Success){
        cacheService.clear('profile');
        $scope.alert.successMessage = 'You have updated your profile.';
        $scope.alert.successShown = true;
        $state.go('member.home.profile.confirmation');
      } else {
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      $scope.alert.alertShown = true;
    }).then(function(){
      $scope.loading = false;
    });
  };
}]);
